export default __webpack_public_path__ + "static/media/agent-type-1.f5ceac35.svg";